import './animation.scss';

export class Animation {
    constructor(target) {
        this.classes = {
            isInView: 'is-in-viewport',
            customTrigger: 'animation--custom-trigger',
        };

        this.element = $(target);

        this.isVisible = false;
        this.image     = this.element.find('.image__img');
        this.isImage   = this.image.length > 0;

        this.init();
    }

    init() {
        this.addIntersectionObserver();
    }

    addIntersectionObserver() {
        if (this.isVisible) {
            return;
        }

        const options = {
            root: null, // Use the viewport as the root
            rootMargin: '0px', // 0px 0px -100px 0px - bottom offset is 100px (triggers after target 100px)
            threshold: .1, // Ratio of the target element which is visible
        };

        const observer = new IntersectionObserver((entries) => { // eslint-disable-line
            entries.map((entry) => {
                if (entry.isIntersecting) {
                    const target = $(entry.target);

                    // Do once
                    if (target.hasClass(this.classes.isInView)) {
                        return;
                    }

                    // if (this.isImage) {
                    //     if (this.image.hasClass('lazyloaded')) {
                    //         this.animateImage();
                    //     } else {
                    //         this.image.on('load', this.animateImage.bind(this));
                    //     }

                    //     return entry;
                    // }

                    target.addClass(this.classes.isInView);

                    this.isVisible = true;
                }
            });
        }, options);

        observer.observe(this.element.get(0));
    }

    animateImage() {
        setTimeout(() => {
            this.element.addClass(this.classes.isInView);
        }, 10);
    }
}
$(() => {
    $('.js-animation').map(function() {
        new Animation(this);
    });
});

